import { Controller } from "@hotwired/stimulus"

declare global {
  interface Window {
    umami?: {
      track: (name: string, data?: Record<string, unknown>) => void
    }
  }
}

export default class extends Controller {
  connect() {
    window.umami?.track("onboarding-picker-shown")
  }

  select(event: Event) {
    const target = event.currentTarget as HTMLElement
    const persona = target.dataset.onboardingPickerPersonaParam
    if (persona) {
      window.umami?.track("onboarding-persona-selected", { persona })
    }
    // Form submission proceeds normally; do not preventDefault.
  }
}
